import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
} from "@insite/client-framework/HandlerCreator";
import { CareerFormModel } from "@tFissco/ApiModels";
import { addCareerFormFields as addCareerFormApi } from "@tFissco/Services/CareerFormService";

type careerParameter = {
    firstName: string;
    lastName: string;
    phone: string;
    emailAddress: string;
    branch: string;
    jobTitle: string;
    attachment: any;
    onSuccess?: () => void;
    onError?: (error: string, statusCode?: number) => void;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<careerParameter, CareerFormModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const SendDataToApi: HandlerType = async props => {
    await addCareerFormApi(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitCareerForm = createHandlerChainRunner(chain, "AddCareerFormFields");
export default submitCareerForm;
